const rejectInfo = {
  orderNo: 'OrderNo',
  deliveryNo: 'DeliveryNo',
  rejectNo: 'RejectNo',
  docStatus: 'DocStatus',
  orderDate: 'OrderDate',
  customerSignDate: 'CustomerSignDate',
  customerCode: 'CustomerCode',
  customerName: 'CustomerName',
  rejectItemMaterialNo: 'RejectItemMaterialNo',
  rejectItemOldCode: 'RejectItemOldCode',
  rejectQty: 'RejectQty',
  rejectLocation: 'RejectLocation',
  productStatus: 'ProductStatus',
  rejectReasonType: 'RejectReasonType',
  rejectReason: 'RejectReason',
  productReturned: 'ProductReturned',
  noticeDate: 'NoticeDate',
  entered3PL: 'Entered3PL',
  remark: 'Remark',
  todayReject: 'TodayReject',
  carrierName: 'Carrier',
  category: 'Category',
  dc: 'DC',
  cscEntryDate: 'CSCEntryDate',
  statusRejectCreate: 'RejectCreated',
  statusPendingApproval: 'PendingApproval',
  statusPendingReceipt: 'PendingReceipt',
  statusRejectDone: 'RejectDone',
  reasonTransportLost: 'TransportLost',
  reasonDamaged: 'Damaged',
  reasonCustomerSpecial: 'CustomerSpecialReq',
  customerPdl: 'PDL',
  customerJsk: 'JSK-MaoChao',
  customerQcs: 'Watsons',
  msg: {}
};
export default rejectInfo;



// WEBPACK FOOTER //
// ./src/page/reject/rejectInfo/lang/rejectInfo.en.js